function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useContext, memo } from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { HStack } from '@cbhq/cds-web/layout/HStack';
import { ThemeProvider } from '@cbhq/cds-web/system/ThemeProvider';
import getCoinbaseLocalizedUrl from '../../utils/getCoinbaseLocalizedUrl.js';
import '../../utils/useIsMobile/index.js';
import '../Link/index.js';
import './constants/index.js';
import GlobalNavContext from './context/GlobalNavContext.js';
import { MOBILE_NAV_HEIGHT } from './MobileNav/constants.js';
import { BoldLabel } from './NavTypography.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import useIsMobile from '../../utils/useIsMobile/useIsMobile.js';
import { MOBILE_BREAKPOINT } from './constants/constants.js';
import Link from '../Link/Link.js';
const NAV_PADDING_VERTICAL = 18;
const NAV_PADDING_HORIZONTAL = 20;
const LINK_ITEM_MARGIN_RIGHT = 30;
const SUBNAV_HEIGHT = 55;
function SubNav({
  links,
  className
}) {
  const isMobile = useIsMobile(MOBILE_BREAKPOINT);
  const _useContext = useContext(GlobalNavContext),
    productName = _useContext.productName,
    productUrl = _useContext.productUrl,
    subNavSecondaryLink = _useContext.subNavSecondaryLink,
    onClickProductName = _useContext.onClickProductName,
    localeCode = _useContext.localeCode;
  const productNameProps = {};
  if (onClickProductName) {
    productNameProps.onClick = onClickProductName;
  }
  const shouldDisplaySubNavSecondaryLink = !isMobile && subNavSecondaryLink;
  return /*#__PURE__*/jsx(Wrapper, {
    $isMobile: isMobile,
    $includesProductName: !!productName,
    className: className,
    children: /*#__PURE__*/jsxs(ContentWrapper, {
      children: [productName ? /*#__PURE__*/jsx(Spacer, {
        children: /*#__PURE__*/jsx(ProductNameText, _objectSpread(_objectSpread({
          to: productUrl || '/'
        }, productNameProps), {}, {
          children: productName
        }))
      }) : /*#__PURE__*/jsx(Spacer, {}), /*#__PURE__*/jsx(LinksWrapper, {
        $isMobile: isMobile,
        children: /*#__PURE__*/jsx(LinksContent, {
          children: links.map(({
            url,
            active,
            label,
            onClick,
            notLocalized
          }, index) => {
            const linkProps = {};
            if (onClick) {
              linkProps.onClick = onClick;
            }
            return /*#__PURE__*/jsx(SubNavLink, _objectSpread(_objectSpread({
              to: (notLocalized ? url : getCoinbaseLocalizedUrl(url || '', localeCode)) || '',
              title: label
            }, linkProps), {}, {
              children: /*#__PURE__*/jsx(LinkText, {
                $active: active,
                children: label
              })
            }), url || label || `sub_nav_link_index_${index}`);
          })
        })
      }), /*#__PURE__*/jsx(Spacer, {}), shouldDisplaySubNavSecondaryLink && /*#__PURE__*/jsx(ThemeProvider, {
        spectrum: "dark",
        children: /*#__PURE__*/jsxs(HStack, {
          alignItems: "center",
          children: [/*#__PURE__*/jsx(Link, {
            to: subNavSecondaryLink.url,
            target: "_blank",
            children: /*#__PURE__*/jsx(LinkText, {
              $active: true,
              children: subNavSecondaryLink.label
            })
          }), /*#__PURE__*/jsx(Link, {
            to: subNavSecondaryLink.url,
            target: "_blank",
            children: /*#__PURE__*/jsx(Icon, {
              size: "s",
              name: "diagonalUpArrow",
              spacingStart: 1
            })
          })]
        })
      })]
    })
  });
}
const SubNav$1 = /*#__PURE__*/memo(SubNav);
const ProductNameText = styled(Link)`
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  top: -1.5px;
  font-size: 18px;
  font-weight: 300;
  white-space: nowrap;
  position: relative;
  color: ${({
  theme
}) => theme.color.text};
  margin-left: ${NAV_PADDING_HORIZONTAL}px;
`;
const Wrapper = styled.nav`
  background: ${({
  theme
}) => theme.color.background};
  display: flex;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid ${({
  theme
}) => theme.color.border};
  ${({
  $isMobile,
  $includesProductName
}) => {
  return $isMobile ? css`
          top: ${MOBILE_NAV_HEIGHT}px;
          ${Spacer} {
            flex: unset;
          }
          ${ContentWrapper} {
            justify-content: flex-start;
          }
          ${LinksContent} {
            justify-content: flex-start;
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch;
          }
          ${LinksWrapper} {
            margin-left: ${$includesProductName ? 12 : 0}px;
          }
          ${SubNavLink}:last-child {
            padding-right: ${NAV_PADDING_HORIZONTAL}px;
          }
        ` : '';
}}
`;
const ContentWrapper = styled.div`
  max-width: ${p => p.theme.layout.width}px;
  margin: 0 auto;
  flex: 1;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  @media screen and (min-width: ${p => p.theme.layout.width}px) {
    padding: 0 ${NAV_PADDING_HORIZONTAL}px;
    box-sizing: content-box;
    ${ProductNameText} {
      margin-left: 0;
    }
  }
`;
const LinksWrapper = styled.div`
  justify-content: center;
  align-items: center;
  ${({
  $isMobile
}) => {
  return $isMobile ? css`
          flex: 1;
          overflow: hidden;
          position: relative;
          justify-content: flex-start;
          &:before {
            position: absolute;
            content: '';
            top: 0;
            left: 0;
            z-index: ${({
    theme
  }) => theme.zIndex.elevated};
            height: 100%;
            pointer-events: none;
            background-image: linear-gradient(
              to left,
              ${({
    theme
  }) => theme.color.background}00,
              ${({
    theme
  }) => theme.color.background}
            );
            width: 24px;
          }
          &:after {
            position: absolute;
            content: '';
            top: 0;
            right: 0;
            z-index: ${({
    theme
  }) => theme.zIndex.elevated};
            height: 100%;
            pointer-events: none;
            background-image: linear-gradient(
              to right,
              ${({
    theme
  }) => theme.color.background}00,
              ${({
    theme
  }) => theme.color.background}
            );
            width: 24px;
          }
        ` : '';
}}
`;
const LinksContent = styled.div`
  padding: ${NAV_PADDING_VERTICAL}px ${NAV_PADDING_HORIZONTAL}px;
  display: flex;
`;
const Spacer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;
const SubNavLink = styled(Link)`
  top: -1px;
  position: relative;
  line-height: 16px;
  white-space: nowrap;
  &:not(:first-child) {
    margin-left: ${LINK_ITEM_MARGIN_RIGHT}px;
  }
`;
const LinkText = styled(BoldLabel)`
  line-height: 18px;
  position: relative;
  color: ${({
  theme,
  $active
}) => $active ? theme.color.textAccent : theme.color.text};
  &:hover {
    color: ${({
  theme
}) => theme.color.textAccentHover};
  }
`;
export { LinksContent, ProductNameText, SUBNAV_HEIGHT, SubNavLink, SubNav$1 as default };
//# sourceMappingURL=SubNav.js.map
